export const NOT_FOUND = -2;
export const DELETED = -3;
export const INTERNAL_ERROR = -100;

export const INCORRECT_MODEL = "MAN-1";
export const CUSTOMER_NOT_FOUND = "MAN-2";
export const SMS_SENDING_ERROR = "MAN-3";
export const ORDER_NOT_FOUND = "MAN-4";

export const USER_NOT_FOUND = "MAN-5";

export const CUSTOMERS_NO_FILTER = "MAN-6";
export const CUSTOMERS_PHONE_IS_ALREADY_REGISTRED = "MAN-7";

export const ORDERS_GET_INCORRECT_STATE_SENT = "MAN-8";
export const ORDERS_MANUAL_COMPLETION_NO_REASON = "MAN-9";
export const ORDERS_MANUAL_COMPLETION_DELIVERY_IN_PROCESS = "MAN-10";
export const ORDERS_GET_INCORRECT_DEPARTMENT_TYPE = "MAN-11";
export const ORDERS_CREATE_REPEATING_SERVICE = "MAN-12";

export const SETTINGS_EMPLOYEE_NO_RECEPTION_POINT = "MAN-13";
export const SETTINGS_EMPLOYEE_LOGIN_IS_ASREADY_EXSISTS = "MAN-14";

export const CATEGORY_NOT_EMPTY = "MAN-15";

export const CALLBACK_NOT_FOUND = "ROOT-1";
export const EMPLOYEE_NOT_FOUND = "ROOT-2";
export const EMPLOYEE_IS_INACTIVE = "ROOT-3";
export const CUSTOMER_PHONE_IS_ALREADY_EXISTS = "ROOT-5";
export const DEPARTMENT_NOT_FOUND = "ROOT-6";
export const EMPLOYEE_LOGIN_IS_ALREADY_EXISTS = "ROOT-7";
export const ORDER_DUPLICATE_SERVICE = "ROOT-8";
export const ORDER_EMPTY_AMOUNT_FOR_SERVICE = "ROOT-9";
export const ORDER_INVALID_PRICE_FOR_SERVICE = "ROOT-10";
export const ORDER_INVALID_CLEANING_TIME_FOR_SERVICE = "ROOT-11";
export const ORDER_IS_DELETED = "ROOT-13";
export const SERVICE_NOT_FOUND = "ROOT-14";
export const SERVICE_IS_INACTIVE = "ROOT-15";
export const CATEGORY_NOT_FOUND = "ROOT-16";
export const CATEGORY_IS_EMPTY = "ROOT-17";
export const IMAGE_NOT_FOUND = "ROOT-18";
export const DELIVERY_SETTINGS_NOT_FOUND = "ROOT-19";
export const WORK_TIME_SETTINGS_NOT_FOUND = "ROOT-20";
export const CUSTOM_WORK_TIME_IS_SAME_DEFAULT = "ROOT-21";
export const WEBSITE_META_NOT_FOUND = "ROOT-22";
export const AGENT_NOT_FOUND = "ROOT-23";
export const FAQ_NOT_FOUND = "ROOT-24";
export const TABLES_SETTINGS_NOT_FOUND = "ROOT-25";
export const INCORRECT_ADDRESS = "ROOT-26";
export const NEWS_NOT_FOUND = "ROOT-28";
export const REVIEW_LIMIT = "ROOT-29";
export const NEWS_DUBLIKAT = "ROOT-30";
export const CATEGORY_DUBLIKAT = "ROOT-31";

export const errors = [
    { Id: INCORRECT_MODEL, Message: 'Передана неверная модель' },
    { Id: CUSTOMER_NOT_FOUND, Message: 'Клиент не найден' },
    { Id: SMS_SENDING_ERROR, Message: 'Ошибка при отправке смс' },
    { Id: ORDER_NOT_FOUND, Message: 'Заказ не найден' },
    { Id: USER_NOT_FOUND, Message: 'Пользователь не найден' },
    { Id: CUSTOMERS_NO_FILTER, Message: 'Не указан фильтр для поиска' },
    { Id: CUSTOMERS_PHONE_IS_ALREADY_REGISTRED, Message: 'Телефон уже используется' },
    { Id: ORDERS_GET_INCORRECT_STATE_SENT, Message: 'Передан неверный статус в фильтре' },
    { Id: ORDERS_MANUAL_COMPLETION_NO_REASON, Message: 'Не указана причина' },
    { Id: ORDERS_MANUAL_COMPLETION_DELIVERY_IN_PROCESS, Message: 'Доставка в процессе' },
    { Id: ORDERS_GET_INCORRECT_DEPARTMENT_TYPE, Message: 'Передан неверный тип отдела' },
    { Id: ORDERS_CREATE_REPEATING_SERVICE, Message: 'Передано более 1 одинакового сервиса' },
    { Id: SETTINGS_EMPLOYEE_NO_RECEPTION_POINT, Message: 'Не выбрана точка приема' },
    { Id: SETTINGS_EMPLOYEE_LOGIN_IS_ASREADY_EXSISTS, Message: 'Логин занят' },
    { Id: CATEGORY_NOT_EMPTY, Message: "Категория содержит услуги" },
    { Id: CALLBACK_NOT_FOUND, Message: 'Обратный звонок не найден' },
    { Id: EMPLOYEE_NOT_FOUND, Message: 'Сотрудник не найден' },
    { Id: EMPLOYEE_IS_INACTIVE, Message: 'Сотрудник не активный' },
    { Id: CUSTOMER_NOT_FOUND, Message: 'Клиент не найден' },
    { Id: CUSTOMER_PHONE_IS_ALREADY_EXISTS, Message: 'Номер сотрудника уже существует' },
    { Id: DEPARTMENT_NOT_FOUND, Message: 'Отдел не найден' },
    { Id: EMPLOYEE_LOGIN_IS_ALREADY_EXISTS, Message: 'Логин сотрудника уже существует' },
    { Id: ORDER_DUPLICATE_SERVICE, Message: 'Дублирующие сервисы в заказе' },
    { Id: ORDER_EMPTY_AMOUNT_FOR_SERVICE, Message: 'Отсутвтвует количество в сервисе заказа' },
    { Id: ORDER_INVALID_PRICE_FOR_SERVICE, Message: 'Неверная цена в сервисе заказа' },
    { Id: ORDER_INVALID_CLEANING_TIME_FOR_SERVICE, Message: 'Неверное время обработки сервиса' },
    { Id: ORDER_NOT_FOUND, Message: 'Заказ не найден' },
    { Id: ORDER_IS_DELETED, Message: 'Заказ удален' },
    { Id: SERVICE_NOT_FOUND, Message: 'Сервис не найден' },
    { Id: SERVICE_IS_INACTIVE, Message: 'Сервис не активен' },
    { Id: CATEGORY_NOT_FOUND, Message: 'Категория не найдена' },
    { Id: CATEGORY_IS_EMPTY, Message: 'Категория пустая' },
    { Id: IMAGE_NOT_FOUND, Message: 'Изображение не найдено' },
    { Id: DELIVERY_SETTINGS_NOT_FOUND, Message: 'Настройки доставки не найдены' },
    { Id: WORK_TIME_SETTINGS_NOT_FOUND, Message: 'Настройки рабочего времени не найдены' },
    { Id: CUSTOM_WORK_TIME_IS_SAME_DEFAULT, Message: 'Кастомное рабочее время совпадает с временем работы по умолчанию' },
    { Id: WEBSITE_META_NOT_FOUND, Message: 'Не найдены настройки меты сайта' },
    { Id: AGENT_NOT_FOUND, Message: 'Агент не найден' },
    { Id: FAQ_NOT_FOUND, Message: 'Вопрос не найден' },
    { Id: TABLES_SETTINGS_NOT_FOUND, Message: 'Настройки таблиц не найдены' },
    { Id: INCORRECT_ADDRESS, Message: 'Невалидный адрес' },
    { Id: NEWS_NOT_FOUND, Message: 'Новость не найдена' },
    { Id: REVIEW_LIMIT, Message: 'Превышен лимит отзывов' },
    { Id: NEWS_DUBLIKAT, Message: 'Новость не может содержать повторяющиеся название' },
    { Id: CATEGORY_DUBLIKAT, Message: 'Категория не может содержать повторяющиеся название' }
];

export function getErrorMessage(errorCode) {
    if (!errorCode)
        return undefined;

    var error = errors.find(e => e.Id == errorCode);
    if (!error)
        return undefined;
    return error.Message;
}


// WEBPACK FOOTER //
// ./src/constants/errorCode.js